import React from "react"
import DefaultTemplate from "../templates/DefaultTemplate";

const Home = () => {
    return(
        <DefaultTemplate title="Home">
            <div>Home<br></br> {process.env.REACT_APP_DOBLOG_BACKEND_PATH}</div>
        </DefaultTemplate>
    )
}

export default Home;